import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || 'Folder'}</title>
      <g>
        <path d="M507.5 177v213.7c0 18.6-6.7 34.6-20 48-13.4 13.4-29.3 20-48 20h-369.1c-18.6 0-34.6-6.7-48-20-13.4-13.4-20-29.3-20-48v-291.4c0-18.6 6.7-34.6 20-48 13.4-13.4 29.3-20 48-20h97.1c18.6 0 34.6 6.7 48 20 13.4 13.4 20 29.3 20 48v9.7h204c18.6 0 34.6 6.7 48 20 13.4 13.4 20 29.4 20 48z" />
      </g>
    </Icon>
  )
}
